import React from "react";
import { useIntl } from "react-intl";

const HepatiticCPositiveDescription = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="row mb-4">
      <div className="col-12">
        <div className="title pl-0">
          {formatMessage({ id: "utils.hepC.title" })}:
        </div>
        {formatMessage({ id: "utils.hepC.description" })}
      </div>
    </div>
  );
};

export default HepatiticCPositiveDescription;
